<h1>THE VENUE</h1>
<h2>Main conference and workshops</h2>
<p> Our main venue for both the main conference and workshops is Banca D'Italia's reception hall <a
        href="https://collezionedarte.bancaditalia.it/-/centro-donato-menichella-ingresso-salone-di-rappresentanza">Centro
        Donato Menichella</a> (Largo Guido Carli 1, 00044 Frascati RM).</p>
<p style="text-align: center;">
    <img src="../../../../../../assets/images/events/2024/cifris24/auditorium_cifris24.jpeg"
        class="venue">
    <img src="../../../../../../assets/images/events/2024/cifris24/foyer_cifris24.jpeg"
        class="venue">
</p>
<hr id="shuttle-service">
<h2>Shuttle service</h2>
<p> We provide a free shuttle service to and from the venue during the event (Sept. 25th, 26th, 27th). <br> <br>
    Shuttles will depart/arrive near the train station "Roma Termini" (Via Cavour 15, in front of <i>Hotel
        Mediterraneo</i>). Both this location and timeslots are subject to change, precise details will be provided at a later date. <br> The trip will last
    between 30 and 60 minutes, depending on traffic conditions.
</p>
<p>
    On Thursday 26th, the conference will end early at 16:40. <br>
    On Friday 27th, it will end at 16:30. <br>
    Shifted timeslots are highlighted in orange.
</p>
<div class="table-wrapper">
    <div>
        <h4> From Rome to the Venue </h4>
        <table>
            <tr>
                <th colspan=4>departure: Via Cavour 15 (Roma Termini)</th>
            </tr>
            <tr>
                <td></td>
                <td class="special">25th</td>
                <td class="special">26th</td>
                <td class="special">27th</td>
            </tr>
            <tr>
                <td>Shuttle I</td>
                <td class="highlight">8:30</td>
                <td class="highlight">8:30</td>
                <td class="highlight">8:30</td>
            </tr>
            <tr>
                <td>Shuttle II</td>
                <td class="highlight">9:00</td>
                <td class="highlight">9:00</td>
                <td class="highlight">9:00</td>
            </tr>
            <tr>
                <td>Shuttle III</td>
                <td class="highlight">12:30</td>
                <td class="highlight">12:30</td>
                <td class="highlight">12:30</td>
            </tr>
            <tr>
                <td>Shuttle IV</td>
                <td class="highlight">13:00</td>
                <td class="highlight">13:00</td>
                <td class="highlight">13:00</td>
            </tr>
        </table>
    </div>
    <div>
        <h4> From the Venue to Rome</h4>
        <table>
            <tr>
                <th colspan=4>departure: Centro Menichella (Frascati)</th>
            </tr>
            <tr>
                <td></td>
                <td class="special">25th</td>
                <td class="special">26th</td>
                <td class="special">27th</td>
            </tr>
            <tr>
                <td>Shuttle I</td>
                <td class="highlight">14:00</td>
                <td class="highlight">14:00</td>
                <td class="highlight">14:00</td>
            </tr>
            <tr>
                <td>Shuttle II</td>
                <td class="highlight">14:30</td>
                <td class="highlight">14:30</td>
                <td class="highlight">14:30</td>
            </tr>
            <tr>
                <td>Shuttle III</td>
                <td class="highlight">17:00</td>
                <td class="highlight-anomalous">16:30</td>
                <td class="highlight-anomalous">16:30</td>
            </tr>
            <tr>
                <td>Shuttle IV</td>
                <td class="highlight">17:30</td>
                <td class="highlight-anomalous">17:00</td>
                <td class="highlight-anomalous">17:00</td>
            </tr>
        </table>
    </div>
</div>